<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="尺码管理" name="list">
				<model-manage></model-manage>
			</el-tab-pane>
			<el-tab-pane label="尺码预置" name="preset">
				<model-preset-manage></model-preset-manage>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import ModelManage from "@/views/Setting/subs/ModelManage.vue";
import ModelPresetManage from "@/views/Setting/subs/ModelPresetManage.vue";

export default {
	mixins: [TabPage],
	components: {
		ModelManage,
		ModelPresetManage
	},
	data() {
		return {
			activeName: "list"
		};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
	watch: {}
};
</script>
<style lang="scss" scoped>
</style>
